export const bp = {
  xsmall: 576,
  small: 768,
  medium: 992,
  large: 1024,
  custom1: 876,
};
export const mq = (breakpoint) => `@media (min-width: ${breakpoint}px)`;
